<script>
    const axios = require('axios');
    import laroute from './../laroute';
    import _ from 'lodash';
    import Lang from 'lang.js';
    import messages from './../messages';

    let default_locale = window.default_locale;
    let fallback_locale = window.fallback_locale;

    let trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );

    function getParameterByName(name, _default) {
        let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        if (match) {
            return decodeURIComponent(match[1].replace(/\+/g, ' '));
        }
        return _default;
    }

    const makeRequestCreator = () => {
      let call;
      return (url, params) => {
        if (call) {
          call.cancel("Subsequent Search");
        }
        call = axios.CancelToken.source();
        return axios.get(url, {
          cancelToken: call.token,
          params
        });
      };
    };
    const get = makeRequestCreator();

    let searchUrl = '/trainings/search/tags';

    export default {

        data() {
            return {
                page: 1,
                laroute,
                query: '',
                hasSearched: false,
                trainings: {
                    data: []
                },
                step: 0,
                role: null,
                selectedTags: [],
                unselectedTags: [],
                mapping: [],
            }
        },

        mounted() {
          get('/trainings/search/assistant').then(data => {
            this.mapping = data.data;
          })
            .catch(error => {
              // error callback because of cancellaction
            });
        },

        computed: {
            showEmptyState() {
                return this.hasSearched && this.trainings.data.length === 0;
            },
        },

        watch: {
            query: _.debounce(function() {
                this.search(this.query);
            }, 300),

            step: function (value) {
              if (value === 4) {
                this.search(this.selectedTags.join(','));
              }
            }

        },

        methods: {
          __(key) {
            if (default_locale === 'en') {
              return key;
            }
            return trans.get('strings.'+key);
          },

          toggleSelectedTag(tag) {
            if (this.selectedTags.includes(tag)) {
              this.selectedTags = this.selectedTags.filter(function (selectedTag) {
                return selectedTag !== tag;
              });

              return;
            }

            this.selectedTags.push(tag);
          },

          isInSelectedTags(tag) {
            return this.selectedTags.includes(tag);
          },

          toggleUnselectedTag(tag) {
            if (this.unselectedTags.includes(tag)) {
              this.unselectedTags = this.unselectedTags.filter(function (selectedTag) {
                return selectedTag !== tag;
              });

              return;
            }

            this.unselectedTags.push(tag);
          },

          isInUnselectedTags(tag) {
            return this.unselectedTags.includes(tag);
          },

            paginate(page) {
                this.page = page;

                get(searchUrl, {
                    q: this.query,
                    page: this.page
                }).then(data => {
                    this.trainings = data.data;

                    window.scrollTo(0,0);
                })
                .catch(error => {
                  // error callback because of cancellaction
                });
            },

            search(query, maintainPage = false) {

                if (! maintainPage) {
                    this.page = 1;
                }

                get(searchUrl, {
                    q: query,
                    page: this.page,
                }).then(data => {
                    this.hasSearched = true;
                    this.trainings = data.data;
                })
                .catch(error => {
                  // error callback because of cancellaction
                });
            },

            applyQueryFilters() {
                // Lookup query parameters...
                this.query = getParameterByName('q', this.query);
                this.page = getParameterByName('page', this.page);
            },

            showTraining(route, training) {
                 document.location.href = laroute.route(route, {'training': training.slug, 'category': training.default_category.slug})
            }
        }
    }
</script>